import { useTranslation } from 'react-i18next'
import { formatNumbers } from 'core/helpers/format-numbers'

import c from './assets/sass/panel.module.scss'

export const Panel = ({
    multiplier = 1.0,
    payout = '0',
    onCashOut,
    lost = false,
    won = false,
    onPlayAgain,
}) => {
    const { t } = useTranslation()
    const winnings = parseInt(payout) || 0

    return (
        <div className={c.component}>
            {lost || won ? (
                <button className={c.button} onClick={onPlayAgain}>
                    {t('mines.panel.playAgain')}
                </button>
            ) : (
                <button className={c.button} onClick={onCashOut}>
                    {t('mines.panel.cashout')}
                </button>
            )}
            <div className={c.prize}>
                {t('mines.panel.winnings')}
                <span>{formatNumbers(winnings)}</span>
            </div>
        </div>
    )
}
